// extracted by mini-css-extract-plugin
export default {"tips":"tipsComponent_tips__HXJXb","tipsBtn":"tipsComponent_tipsBtn__+xH5i"};